import React from 'react';
import styled from 'styled-components';
import {
  Row,
  Col,
  Menu,
  Avatar,
  Icon,
  Badge,
  Button,
} from 'antd';
import { isIE } from 'utils/browsers';
import colors from './colors';

export const Wrapper = styled(Row)`
  -webkit-box-shadow: 0px 2px 3px 0px rgba(204,204,204,0.50);
  -moz-box-shadow: 0px 2px 3px 0px rgba(204,204,204,0.50);
  box-shadow: 0px 2px 3px 0px rgba(204,204,204,0.50);
  background-color: #FFFFFF;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
  display: flex !important;
  flex-wrap: nowrap !important;
  align-items: center;
`;

export const NavWrapper = styled(Menu)`
  border-bottom: 0 !important;
  display: flex !important;
  flex-wrap: nowrap !important;
  align-items: center;
`;

export const LogoWrapper = styled(Col)`
  display: flex !important;
  align-items: center;
  justify-content: center;
  height: 60px;
  flex-shrink: 0;
  min-width: 100px;
  
  @media (max-width: 992px) {
    min-width: 80px;
  }
`;

export const Logo = styled.div`
  width: 100%;
  height: 100%;
  cursor: pointer;
  margin: 10px;
  background: ${({ logo }) => `url("${logo}") no-repeat center / contain`};
`;

export const NavItem = styled(Menu.Item)`
  height: 60px;
  line-height: 60px;
  text-transform: uppercase;
  padding: 0 40px !important;
  height: 100%;
  flex-shrink: 0;
  white-space: nowrap;
  
  /* Tablet breakpoint - reduce padding */
  @media (max-width: 1200px) {
    padding: 0 24px !important;
  }
  
  @media (max-width: 992px) {
    padding: 0 16px !important;
    font-size: 12px;
  }
  
  ${({ border }) => (border && `
    border-right: 1px solid #ccc;
    border-left: 1px solid #ccc;
  `)}
`;

export const PrimaryItem = styled(NavItem)`
  border-right: 1px solid #ccc;
  border-left: 1px solid #ccc;
`;

export const ItemContent = styled.div`
  display: flex;
  align-items: center;
`;

export const CloseReport = (props) => (
  <Button size="small" style={{ marginLeft: '10px' }} {...props}>
    <Icon style={{ marginRight: '0px' }} type="close" />
  </Button>
);

export const UserWrapper = styled(Col)`
  height: 100%;
  flex-shrink: 0;
  white-space: nowrap;
`;

export const UserDropdown = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 60px;
  cursor: pointer;
  text-transform: uppercase;
  white-space: nowrap;
`;

export const UserAvatar = styled(Avatar)`
  margin-right: 16px !important;
  background-color: ${colors.Primary} !important;
  flex-shrink: 0;
  
  @media (max-width: 992px) {
    margin-right: 8px !important;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  min-width: 0;
  flex-shrink: 1;
`;

export const UserName = styled.div`
  line-height: 1.6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
  
  @media (max-width: 1200px) {
    max-width: 100px;
  }
  
  @media (max-width: 992px) {
    max-width: 80px;
    font-size: 11px;
  }
`;

export const UserCompany = styled.div`
  font-size: 8pt;
  color: #aaa;
  line-height: 1.2;
  text-transform: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
  
  @media (max-width: 1200px) {
    max-width: 100px;
  }
  
  @media (max-width: 992px) {
    max-width: 80px;
    font-size: 7pt;
  }
`;

export const DropdownArrow = styled(Icon)`
  font-size: 20px !important;
  margin-right: 16px;
  margin-left: 16px;
  color: ${colors.LighterGray};
  flex-shrink: 0;
  
  @media (max-width: 992px) {
    margin-right: 8px;
    margin-left: 8px;
  }
`;

export const Counter = (props) => (
  <Badge
    {...props}
    style={{
      backgroundColor: '#FFF2E8',
      color: '#FA541C',
      marginLeft: '5px',
      border: '1px solid #FFBB96',
      zIndex: 0,
      fontSize: isIE ? '14pt' : null,
    }}
  />
);
